import { GenericFailure } from '@playq/services-shared';
import { App } from '@playq/octopus2-apps';

import { IInvokeScriptsHook } from '/common/scripts/types';
import { UseMutationOptionsExtended } from '/api/service-hooks';

import { useEitherMutationScripted } from '../scriptsService/useEitherMutationScripted';

import { appsService, appsServiceName, createAppMutationKey } from './constants';
import { IAppCreateOptionsVariables, ICreateAppParams } from './types';

export const useAppCreateScripted = (
  scriptsResolver: IInvokeScriptsHook,
  options?: UseMutationOptionsExtended<App, GenericFailure | Error, IAppCreateOptionsVariables>
) =>
  useEitherMutationScripted<ICreateAppParams, App, IInvokeScriptsHook>({
    serviceMethod: appsService.create.bind(appsService),
    scriptsResolver,
    snackbarMessageMetadata: {
      serviceName: appsServiceName,
      mutationType: 'app creation',
    },
    options: {
      mutationKey: createAppMutationKey,

      ...options,
    },
  });
